module.exports = __webpack_public_path__ + "img/vip@3x.709f094b.png";